export default "__VITE_ASSET__D2i5EJFk__"